/**
 * STTY Theme — theme.js
 * Vanilla JS only. All logic runs after DOMContentLoaded.
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================================
     1. Mobile menu toggle — owned by sections/header.liquid
     The drawer is opened and closed by the inline script in the
     header section, which toggles .is-open on the drawer and
     .menu-open on the header — the classes theme.css actually
     styles. A second handler used to live here toggling
     body.nav-open and binding a .nav-overlay element; neither
     appears in any stylesheet or template, so it did nothing but
     double-fire aria-expanded on the burger. Removed.

     2. Reading preferences — owned by snippets/accessibility-panel.liquid
     Font style, text size, line spacing and background colour are
     set in the accessibility panel and applied to <html> before
     first paint by the inline script in layout/theme.liquid.
     ============================================================ */


  /* ============================================================
     3. Cart count
     Fetches /cart.js on load and updates every .cart-count element.
     Re-fetches 600ms after any add-to-cart form submission so the
     count reflects the newly added item. Changes are announced via
     #cart-status so the update is not silent for screen readers.
     ============================================================ */
  var cartStatus = document.getElementById('cart-status');
  var lastCount  = null;

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var noun  = count === 1 ? ' item' : ' items';

        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = count;
        });
        document.querySelectorAll('.mobile-cart-count').forEach(function (el) {
          el.textContent = count;
        });

        // The mobile button's label is rendered by Liquid, so it goes
        // stale as soon as the count changes — keep it in sync.
        var mobileCartBtn = document.querySelector('.mobile-cart-btn');
        if (mobileCartBtn) {
          mobileCartBtn.setAttribute('aria-label', 'Cart (' + count + noun + ')');
        }

        // Announce genuine changes only — not the initial page-load sync.
        if (cartStatus && lastCount !== null && count !== lastCount) {
          cartStatus.textContent = 'Basket updated: ' + count + noun;
        }
        lastCount = count;
      })
      .catch(function () { /* silently ignore network errors */ });
  }

  refreshCartCount();

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      setTimeout(refreshCartCount, 600);
    });
  });


  /* ============================================================
     4. Product image gallery
     Clicking a thumbnail inside .product-thumbs updates .product-img-main.
     Thumbnails should carry data-full="<full-size-url>" for best quality.
     ============================================================ */
  var mainImg = document.querySelector('.product-img-main');

  if (mainImg) {
    document.querySelectorAll('.product-thumbs img').forEach(function (thumb) {
      thumb.style.cursor = 'pointer';

      thumb.addEventListener('click', function () {
        // Prefer data-full (1200px variant), fall back to thumb src
        mainImg.src = thumb.dataset.full || thumb.src;

        // Update active state
        document.querySelectorAll('.product-thumbs img').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }


  /* ============================================================
     5. Announcement bar — hide on scroll down, reveal on scroll up
     ============================================================ */
  var siteHeader      = document.getElementById('site-header');
  var lastScrollY     = 0;
  var scrollThreshold = 10; // px before triggering

  window.addEventListener('scroll', function () {
    var currentY = window.scrollY;

    if (currentY > lastScrollY && currentY > scrollThreshold) {
      // Scrolling down — hide announcement bar
      siteHeader && siteHeader.classList.add('announcement-hidden');
    } else {
      // Scrolling up — reveal announcement bar
      siteHeader && siteHeader.classList.remove('announcement-hidden');
    }

    lastScrollY = currentY;
  }, { passive: true });


  /* ============================================================
     6. Generic Slideshow helper
     Used by: layered-slideshow, slideshow-fullframe, slideshow-inset,
              carousel (generic)
     Finds every [data-section-id] element that has .is-active slides,
     wires up prev/next arrows, dot indicators, and 4s auto-advance.
     ============================================================ */
  function initSlideshow(container, opts) {
    opts = opts || {};
    var slideSelector  = opts.slideSelector  || '.layered-slideshow__slide, .slideshow-fullframe__slide, .slideshow-inset__slide, .generic-carousel__slide';
    var prevSelector   = opts.prevSelector   || '[class*="__arrow--prev"]';
    var nextSelector   = opts.nextSelector   || '[class*="__arrow--next"]';
    var dotSelector    = opts.dotSelector    || '[class*="__dot"]';
    var autoAdvance    = opts.autoAdvance !== false;
    var interval       = opts.interval       || 4000;

    var slides = Array.from(container.querySelectorAll(slideSelector)).filter(function(s) {
      return container === s.closest('[data-section-id]') || container.contains(s);
    });

    // Narrow to direct children slides only (avoid nested slideshows)
    var trackEl = container.querySelector('[class*="__track"]');
    if (trackEl) {
      slides = Array.from(trackEl.children).filter(function(el) {
        return el.classList.toString().indexOf('__slide') !== -1;
      });
    }

    if (!slides.length) return;

    var current = 0;
    var timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');

      // Update dots
      var dots = container.querySelectorAll(dotSelector);
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', String(i === current));
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    var prevBtn = container.querySelector(prevSelector);
    var nextBtn = container.querySelector(nextSelector);
    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { next(); resetTimer(); });

    container.querySelectorAll(dotSelector).forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); resetTimer(); });
    });

    function resetTimer() {
      clearInterval(timer);
      if (autoAdvance) timer = setInterval(next, interval);
    }

    if (autoAdvance && slides.length > 1) timer = setInterval(next, interval);
  }

  // Init all slideshow sections
  document.querySelectorAll('.layered-slideshow, .slideshow-fullframe, .slideshow-inset, .generic-carousel').forEach(function(el) {
    initSlideshow(el);
  });


  /* ============================================================
     7. Carousel prev/next scroll (collection-list-carousel,
        featured-collection-carousel, blog-posts-carousel)
     ============================================================ */
  function initScrollCarousel(container) {
    var track   = container.querySelector('[class*="__track"]');
    var prevBtn = container.querySelector('[class*="__btn--prev"]');
    var nextBtn = container.querySelector('[class*="__btn--next"]');

    if (!track) return;

    function getCardWidth() {
      var firstCard = track.firstElementChild;
      if (!firstCard) return 280;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0) || 20;
      return firstCard.offsetWidth + gap;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -getCardWidth() * 2, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: getCardWidth() * 2, behavior: 'smooth' });
      });
    }
  }

  document.querySelectorAll('.col-carousel, .feat-col-carousel, .blog-carousel').forEach(function(el) {
    initScrollCarousel(el);
  });


  /* ============================================================
     8. FAQ accordion
     ============================================================ */
  document.querySelectorAll('.faq-section').forEach(function(section) {
    section.querySelectorAll('.faq-section__question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item    = btn.closest('.faq-section__item');
        var isOpen  = item.classList.contains('is-open');

        // Close all in this section
        section.querySelectorAll('.faq-section__item').forEach(function(i) {
          i.classList.remove('is-open');
          i.querySelector('.faq-section__question').setAttribute('aria-expanded', 'false');
        });

        // Open clicked (unless it was already open)
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });


  /* ============================================================
     9. Product hotspots — toggle popups on dot click
     ============================================================ */
  document.querySelectorAll('.hotspots').forEach(function(section) {
    var sectionId = section.dataset.sectionId;

    section.querySelectorAll('.hotspots__dot').forEach(function(dot) {
      dot.addEventListener('click', function(e) {
        e.stopPropagation();
        var key     = dot.dataset.hotspot;
        var popup   = section.querySelector('#hotspot-popup-' + key);
        var isOpen  = dot.getAttribute('aria-expanded') === 'true';

        // Close all
        section.querySelectorAll('.hotspots__dot').forEach(function(d) {
          d.setAttribute('aria-expanded', 'false');
        });
        section.querySelectorAll('.hotspots__popup').forEach(function(p) {
          p.setAttribute('aria-hidden', 'true');
        });

        // Toggle current
        if (!isOpen && popup) {
          dot.setAttribute('aria-expanded', 'true');
          popup.setAttribute('aria-hidden', 'false');
        }
      });
    });

    // Close buttons inside popups
    section.querySelectorAll('.hotspots__popup-close').forEach(function(closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var popup = closeBtn.closest('.hotspots__popup');
        if (popup) popup.setAttribute('aria-hidden', 'true');
        section.querySelectorAll('.hotspots__dot').forEach(function(d) {
          d.setAttribute('aria-expanded', 'false');
        });
      });
    });

    // Close on outside click
    document.addEventListener('click', function() {
      section.querySelectorAll('.hotspots__dot').forEach(function(d) {
        d.setAttribute('aria-expanded', 'false');
      });
      section.querySelectorAll('.hotspots__popup').forEach(function(p) {
        p.setAttribute('aria-hidden', 'true');
      });
    });
  });


  /* ============================================================
     10. Recommended products
     Fetches Shopify's product recommendations API and renders
     product cards. Only runs on product pages.
     ============================================================ */
  var recSection = document.querySelector('.recommended-products');
  if (recSection && document.body.classList.contains('template-product')) {
    var productId = recSection.dataset.productId;
    var limit     = recSection.dataset.limit || 4;
    var grid      = document.getElementById('RecommendedProductsGrid-' + recSection.dataset.sectionId);

    if (productId && grid) {
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!data.products || !data.products.length) {
            recSection.style.display = 'none';
            return;
          }
          var html = data.products.map(function(p) {
            var img = p.featured_image
              ? '<img src="' + p.featured_image + '" alt="' + (p.title || '') + '" class="feat-col-grid__image" loading="lazy">'
              : '<div class="feat-col-grid__placeholder-image"></div>';
            return [
              '<a href="' + p.url + '" class="recommended-products__card" style="text-decoration:none;display:block;border-radius:var(--radius-lg);overflow:hidden;background:var(--color-white);box-shadow:0 2px 8px rgba(0,0,0,0.06)">',
              img,
              '<div style="padding:14px">',
              '<p style="font-family:var(--font-heading);font-weight:800;font-size:15px;color:var(--color-text);margin-bottom:4px">' + (p.title || '') + '</p>',
              '<p style="font-family:var(--font-heading);font-weight:700;font-size:14px;color:var(--color-primary)">' + formatMoney(p.price) + '</p>',
              '</div>',
              '</a>'
            ].join('');
          }).join('');
          grid.innerHTML = html;
        })
        .catch(function() {
          recSection.style.display = 'none';
        });
    }
  }

  function formatMoney(cents) {
    return '\u00a3' + (cents / 100).toFixed(2);
  }


  /* ============================================================
     11. Image compare — drag slider
     ============================================================ */
  document.querySelectorAll('[data-image-compare]').forEach(function(container) {
    var handle   = container.querySelector('.image-compare__handle');
    var afterWrap = container.querySelector('.image-compare__after-wrap');
    if (!handle || !afterWrap) return;

    var dragging = false;

    function setPosition(clientX) {
      var rect  = container.getBoundingClientRect();
      var x     = clientX - rect.left;
      var pct   = Math.min(Math.max(x / rect.width * 100, 0), 100);
      afterWrap.style.width = pct + '%';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    handle.addEventListener('mousedown', function(e) { dragging = true; e.preventDefault(); });
    handle.addEventListener('touchstart', function(e) { dragging = true; }, { passive: true });

    document.addEventListener('mousemove', function(e) {
      if (dragging) setPosition(e.clientX);
    });
    document.addEventListener('touchmove', function(e) {
      if (dragging) setPosition(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('mouseup',  function() { dragging = false; });
    document.addEventListener('touchend', function() { dragging = false; });

    // Keyboard support
    handle.addEventListener('keydown', function(e) {
      var val = parseFloat(afterWrap.style.width) || 50;
      if (e.key === 'ArrowLeft')  { afterWrap.style.width = Math.max(val - 2, 0) + '%'; handle.style.left = afterWrap.style.width; }
      if (e.key === 'ArrowRight') { afterWrap.style.width = Math.min(val + 2, 100) + '%'; handle.style.left = afterWrap.style.width; }
    });
  });

});
